export const SUCCESS_QUERY_PARAM = 'subscription_purchase_successful';

export const LOCAL_STORAGE_PURCHASE_CONFIRMED_KEY =
  'stripe_subscription_purchase_confirmed';
